import { Component, Input } from '@angular/core';
import { APIReferenceDetailXMLSection } from 'src/app/model/section/api-references-details-xml-section';
import { Section } from 'src/app/model/shared/section';

@Component({
  selector: 'app-additional-page-accordian-section',
  templateUrl: './additional-page-accordian-section.component.html',
  styleUrls: ['./additional-page-accordian-section.component.scss']
})
export class AdditionalPageAccordianSectionComponent {
  @Input() additionalAccordianSections: Section[] = [];
  @Input() isDefault: boolean = true;
  @Input() responsePage: boolean = false;
  @Input() apiReferenceDetailXMLSections: APIReferenceDetailXMLSection[] = [];

  collapsed: boolean[] = [];
  isIconTrue: boolean[] = [];

  constructor() {}

  ngOnInit(): void {
    this.additionalAccordianSections?.forEach((i) => {
      this.collapsed.push(false);
    });
  }

  toggleCollapsed(index: number) {
    this.collapsed[index] = !this.collapsed[index];
    this.isIconTrue[index] = !this.isIconTrue[index];
  }

  getAccordionStyle(index: number) {
    return this.collapsed[index] ? 'not-collapsed' : 'collapsed';
  }

  getArrowIcons(index: number) {
    return this.isIconTrue[index] ? 'icon-arrowUp' : 'icon-arrowDown';
  }
}
